import * as React from "react"
import { TopPartiesComponent } from "src/frontend/components/Shared/Layout/Components/Lists/TopPartiesComponent"
import { useTopPartiesLiveData } from "src/frontend/components/Shared/Layout/Components/Lists/useTopPartiesLiveData"
import { useConfigOriginOverride } from "src/frontend/components/Shared/Layout/hooks/useConfigOriginOverride"
import { type TopEntitiesProps } from "src/frontend/components/Shared/Portals/Components/Lists/Shared"
import { type PartyTransactionSummary } from "src/frontend/types"

/*
  COMPONENTS
*/

export const TopParties: React.FC<TopEntitiesProps> = ({ component, componentSize }) => {
  const overriddenConfig = useConfigOriginOverride(component.config.topEntities, 1)
  const config = React.useMemo(
    () => ({ ...component.config, topEntities: overriddenConfig }),
    [component.config, overriddenConfig]
  )
  const { data, loading } = useTopPartiesLiveData(overriddenConfig, component.config.type)

  const summaries: PartyTransactionSummary[] | undefined = React.useMemo(
    () =>
      data?.entities.party.map((p) => ({
        party: p.party,
        summary: p.summary,
        categoryNames: p.by.categories.map((c) => c.category.name).sort(),
      })),
    [data]
  )

  return (
    <TopPartiesComponent
      config={config}
      componentSize={componentSize}
      summaries={summaries}
      loading={loading}
    />
  )
}
